import { forwardRef } from 'react'
import { Trophy, Crown } from 'lucide-react'
import { LeaderboardEntry } from '@/types'
import LeaderboardItem from './LeaderboardItem'

interface LeaderboardContainerProps {
  title: string
  subtitle: string
  entries: LeaderboardEntry[]
  type: 'today' | 'total'
  emptyMessage?: string
}

const LeaderboardContainer = forwardRef<HTMLDivElement, LeaderboardContainerProps>(
  ({ title, subtitle, entries, type, emptyMessage }, ref) => {
    const getIcon = () => {
      return type === 'today' ? (
        <Trophy className="h-6 w-6 text-yellow-500 mr-2 flex-shrink-0" />
      ) : (
        <Crown className="h-6 w-6 text-yellow-500 mr-2 flex-shrink-0" />
      )
    }

    return (
      <div 
        ref={ref} 
        className="bg-white/80 backdrop-blur-xl border border-gray-200/50 rounded-2xl shadow-xl overflow-hidden"
      >
        {/* 标题区域 */}
        <div className="p-4 border-b border-gray-100/50 text-center">
          <div className="flex items-center justify-center mb-1">
            {getIcon()}
            <h3
              className="text-xl font-bold text-gray-900"
              style={{
                lineHeight: '1.5',
                display: 'flex',
                alignItems: 'center',
                height: '24px' // 与图标高度一致
              }}
            >
              {title}
            </h3>
          </div>
          <p className="text-sm text-gray-500">
            {subtitle}
          </p>
        </div>

        {/* 排行榜内容 */}
        {entries.length > 0 ? (
          <div className="divide-y divide-gray-100/50">
            {entries.map((entry: LeaderboardEntry, index: number) => (
              <LeaderboardItem
                key={entry.user.id}
                entry={entry}
                rank={index + 1}
                type={type}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            {type === 'today' ? (
              <Trophy className="mx-auto h-10 w-10 text-gray-400 mb-3" />
            ) : (
              <Crown className="mx-auto h-10 w-10 text-gray-400 mb-3" />
            )}
            <p className="text-gray-500 text-sm">
              {emptyMessage || '暂无数据'}
            </p>
          </div>
        )}
      </div>
    )
  }
)

LeaderboardContainer.displayName = 'LeaderboardContainer'

export default LeaderboardContainer
